// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DelegateSubtasksModal-module__modalOverlay___VWJtZ {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.DelegateSubtasksModal-module__modalCard___iKlHj {
  width: 100%;
  max-width: 640px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.DelegateSubtasksModal-module__modalHeader___EXQ9p {
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.DelegateSubtasksModal-module__modalTitle___fxMsZ {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.DelegateSubtasksModal-module__modalSubtitle___DgINS {
  margin-top: 2px;
  font-size: 14px;
  line-height: 1.45;
  color: #6b7280;
}

.DelegateSubtasksModal-module__modalSubtitleStrong___brJ8T {
  color: #374151;
  font-weight: 500;
}

.DelegateSubtasksModal-module__modalBody___nMJtF {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 60vh;
  overflow-y: auto;
}

.DelegateSubtasksModal-module__subtaskCard___t6l_f {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.DelegateSubtasksModal-module__subtaskCardHeader___ONwrk {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.DelegateSubtasksModal-module__subtaskLabel___R4cLS {
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
  font-family: "IBM Plex Mono", monospace;
}

.DelegateSubtasksModal-module__removeSubtaskButton___j7xtR {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin-right: -4px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
}

.DelegateSubtasksModal-module__removeSubtaskButton___j7xtR:hover {
  color: #374151;
}

.DelegateSubtasksModal-module__textInput___nD7E8,
.DelegateSubtasksModal-module__textarea___hQMxJ,
.DelegateSubtasksModal-module__dateInput___iGW2E,
.DelegateSubtasksModal-module__prioritySelect___DHP6b,
.DelegateSubtasksModal-module__userSearchInput___Y6vYO {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  outline: none;
}

.DelegateSubtasksModal-module__textInput___nD7E8::placeholder,
.DelegateSubtasksModal-module__textarea___hQMxJ::placeholder,
.DelegateSubtasksModal-module__userSearchInput___Y6vYO::placeholder {
  color: #9ca3af;
}

.DelegateSubtasksModal-module__textInput___nD7E8:focus,
.DelegateSubtasksModal-module__textarea___hQMxJ:focus,
.DelegateSubtasksModal-module__dateInput___iGW2E:focus,
.DelegateSubtasksModal-module__prioritySelect___DHP6b:focus,
.DelegateSubtasksModal-module__userSearchInput___Y6vYO:focus {
  border-color: #9ca3af;
}

.DelegateSubtasksModal-module__textarea___hQMxJ {
  min-height: 56px;
  resize: vertical;
}

.DelegateSubtasksModal-module__subtaskControlsRow___t7sfG {
  display: flex;
  align-items: center;
  gap: 8px;
}

.DelegateSubtasksModal-module__assigneePickerWrap___rCBLo {
  position: relative;
  min-width: 200px;
}

.DelegateSubtasksModal-module__assigneeTrigger___F7tTB {
  width: 100%;
  min-height: 34px;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  cursor: pointer;
}

.DelegateSubtasksModal-module__assigneeTriggerActive___YENIB {
  background: #ffffff;
  color: #111827;
}

.DelegateSubtasksModal-module__assigneePlaceholder___m9FxJ {
  flex: 1;
}

.DelegateSubtasksModal-module__assigneePrimary___MEDFE {
  flex: 1;
  min-width: 0;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.DelegateSubtasksModal-module__assigneeSecondary___q22Dv {
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7280;
}

.DelegateSubtasksModal-module__userAvatar___WdvCT {
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: #111827;
  color: #f9fafb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 600;
}

.DelegateSubtasksModal-module__teamAvatar___i227Z {
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #b45309;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 11px;
  font-family: "IBM Plex Mono", monospace;
}

.DelegateSubtasksModal-module__assigneePopover___yKOi0 {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 1001;
  width: 360px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.DelegateSubtasksModal-module__assigneePopoverTabs___GImiM {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
}

.DelegateSubtasksModal-module__assigneePopoverTab___OnqVT {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  border: none;
  border-bottom: 2px solid transparent;
  background: #ffffff;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.DelegateSubtasksModal-module__assigneePopoverTabActive___bJiW9 {
  color: #111827;
  border-bottom-color: #111827;
}

.DelegateSubtasksModal-module__teamPickerBody___YRABz {
  padding: 12px;
}

.DelegateSubtasksModal-module__teamPickerHint___SuQh1 {
  margin-bottom: 8px;
  font-size: 12px;
  color: #6b7280;
}

.DelegateSubtasksModal-module__teamPickerGrid___znmbm {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.DelegateSubtasksModal-module__teamPickerCard___yAu9r {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  color: #374151;
  cursor: pointer;
  text-align: left;
}

.DelegateSubtasksModal-module__teamPickerCardActive___exU1B {
  background: #fffbeb;
  border-color: #fcd34d;
  color: #b45309;
}

.DelegateSubtasksModal-module__teamPickerIcon___SoAqN {
  flex-shrink: 0;
  font-size: 16px;
  font-family: "IBM Plex Mono", monospace;
}

.DelegateSubtasksModal-module__teamPickerLabel___oD43Q {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

.DelegateSubtasksModal-module__userPickerBody___pGHI8 {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.DelegateSubtasksModal-module__userSearchWrap___I74rj {
  padding: 12px 12px 8px;
  border-bottom: 1px solid #e5e7eb;
}

.DelegateSubtasksModal-module__userPickerList___RkiHY {
  max-height: 320px;
  overflow-y: auto;
}

.DelegateSubtasksModal-module__userTeamSection___RlEaV {
  border-bottom: 1px solid #f3f4f6;
}

.DelegateSubtasksModal-module__userTeamHeader___uaEuj {
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
}

.DelegateSubtasksModal-module__userTeamHeaderLeft___xj80y {
  display: flex;
  align-items: center;
  gap: 8px;
}

.DelegateSubtasksModal-module__userTeamChevron___z3XOW {
  font-size: 12px;
  color: #9ca3af;
  transition: transform 0.15s ease;
}

.DelegateSubtasksModal-module__userTeamChevronOpen___zFYut {
  transform: rotate(90deg);
}

.DelegateSubtasksModal-module__userTeamIcon___mHOV4 {
  font-size: 14px;
  color: #6b7280;
  font-family: "IBM Plex Mono", monospace;
}

.DelegateSubtasksModal-module__userTeamTitle___Pduap {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.DelegateSubtasksModal-module__userTeamCount___su4O1 {
  font-size: 12px;
  color: #6b7280;
}

.DelegateSubtasksModal-module__userTeamList___oKeV_ {
  display: flex;
  flex-direction: column;
}

.DelegateSubtasksModal-module__userPickerRow___roGHY {
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-left: 2px solid transparent;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  cursor: pointer;
}

.DelegateSubtasksModal-module__userPickerRow___roGHY:hover {
  background: #f9fafb;
}

.DelegateSubtasksModal-module__userPickerRowActive___KCJYY {
  background: #f3f4f6;
  border-left-color: #111827;
}

.DelegateSubtasksModal-module__userPickerAvatar___HvW_n {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #374151;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
}

.DelegateSubtasksModal-module__userPickerInfo___XZUYx {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.DelegateSubtasksModal-module__userPickerNameRow___OniBM {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.DelegateSubtasksModal-module__userPickerName___Y3GoN {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.DelegateSubtasksModal-module__userPickerYou___OOCrl {
  font-size: 12px;
  color: #6b7280;
}

.DelegateSubtasksModal-module__userPickerRole___fihjm {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.DelegateSubtasksModal-module__userPickerBadge___R6wNl {
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7280;
}

.DelegateSubtasksModal-module__dateInput___iGW2E {
  width: 136px;
}

.DelegateSubtasksModal-module__prioritySelect___DHP6b {
  width: 86px;
  text-transform: capitalize;
}

.DelegateSubtasksModal-module__addSubtaskButton___W4JbJ {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #4b5563;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.DelegateSubtasksModal-module__addSubtaskButton___W4JbJ:hover {
  color: #111827;
  background: #f9fafb;
}

.DelegateSubtasksModal-module__modalFooter___auuiU {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.DelegateSubtasksModal-module__modalSecondaryAction___fLCg2,
.DelegateSubtasksModal-module__modalPrimaryAction___Aip7S {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.DelegateSubtasksModal-module__modalSecondaryAction___fLCg2 {
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #4b5563;
}

.DelegateSubtasksModal-module__modalPrimaryAction___Aip7S {
  border: none;
  background: #111827;
  color: #f9fafb;
}

.DelegateSubtasksModal-module__modalPrimaryAction___Aip7S:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: default;
}

@media (max-width: 720px) {
  .DelegateSubtasksModal-module__modalCard___iKlHj {
    max-width: 100%;
  }
  .DelegateSubtasksModal-module__subtaskControlsRow___t7sfG {
    flex-direction: column;
    align-items: stretch;
  }
  .DelegateSubtasksModal-module__assigneePickerWrap___rCBLo,
  .DelegateSubtasksModal-module__dateInput___iGW2E,
  .DelegateSubtasksModal-module__prioritySelect___DHP6b {
    width: 100%;
  }
  .DelegateSubtasksModal-module__assigneePopover___yKOi0 {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/DelegateSubtasksModal/DelegateSubtasksModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;;;;;EAKE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;;;EAGE,cAAA;AACF;;AAEA;;;;;EAKE,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gCAAA;AACF;;AAEA;EACE,OAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,4BAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,uCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,gCAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gCAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,0BAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AACF;;AAEA;;EAEE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;EAEA;IACE,sBAAA;IACA,oBAAA;EAAF;EAGA;;;IAGE,WAAA;EADF;EAIA;IACE,WAAA;EAFF;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.modalCard {\n  width: 100%;\n  max-width: 640px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modalTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modalSubtitle {\n  margin-top: 2px;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #6b7280;\n}\n\n.modalSubtitleStrong {\n  color: #374151;\n  font-weight: 500;\n}\n\n.modalBody {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.subtaskCard {\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #ffffff;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.subtaskCardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.subtaskLabel {\n  font-size: 12px;\n  font-weight: 500;\n  color: #9ca3af;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.removeSubtaskButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  margin-right: -4px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n}\n\n.removeSubtaskButton:hover {\n  color: #374151;\n}\n\n.textInput,\n.textarea,\n.dateInput,\n.prioritySelect,\n.userSearchInput {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #111827;\n  font-size: 14px;\n  outline: none;\n}\n\n.textInput::placeholder,\n.textarea::placeholder,\n.userSearchInput::placeholder {\n  color: #9ca3af;\n}\n\n.textInput:focus,\n.textarea:focus,\n.dateInput:focus,\n.prioritySelect:focus,\n.userSearchInput:focus {\n  border-color: #9ca3af;\n}\n\n.textarea {\n  min-height: 56px;\n  resize: vertical;\n}\n\n.subtaskControlsRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.assigneePickerWrap {\n  position: relative;\n  min-width: 200px;\n}\n\n.assigneeTrigger {\n  width: 100%;\n  min-height: 34px;\n  padding: 8px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.assigneeTriggerActive {\n  background: #ffffff;\n  color: #111827;\n}\n\n.assigneePlaceholder {\n  flex: 1;\n}\n\n.assigneePrimary {\n  flex: 1;\n  min-width: 0;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.assigneeSecondary {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.userAvatar {\n  width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  background: #111827;\n  color: #f9fafb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.teamAvatar {\n  width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  color: #b45309;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 11px;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.assigneePopover {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 1001;\n  width: 360px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n}\n\n.assigneePopoverTabs {\n  display: flex;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.assigneePopoverTab {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: #ffffff;\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.assigneePopoverTabActive {\n  color: #111827;\n  border-bottom-color: #111827;\n}\n\n.teamPickerBody {\n  padding: 12px;\n}\n\n.teamPickerHint {\n  margin-bottom: 8px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.teamPickerGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.teamPickerCard {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #374151;\n  cursor: pointer;\n  text-align: left;\n}\n\n.teamPickerCardActive {\n  background: #fffbeb;\n  border-color: #fcd34d;\n  color: #b45309;\n}\n\n.teamPickerIcon {\n  flex-shrink: 0;\n  font-size: 16px;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.teamPickerLabel {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.userPickerBody {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.userSearchWrap {\n  padding: 12px 12px 8px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.userPickerList {\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.userTeamSection {\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.userTeamHeader {\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  background: #f9fafb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  text-align: left;\n}\n\n.userTeamHeaderLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.userTeamChevron {\n  font-size: 12px;\n  color: #9ca3af;\n  transition: transform 0.15s ease;\n}\n\n.userTeamChevronOpen {\n  transform: rotate(90deg);\n}\n\n.userTeamIcon {\n  font-size: 14px;\n  color: #6b7280;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.userTeamTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.userTeamCount {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.userTeamList {\n  display: flex;\n  flex-direction: column;\n}\n\n.userPickerRow {\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-left: 2px solid transparent;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.userPickerRow:hover {\n  background: #f9fafb;\n}\n\n.userPickerRowActive {\n  background: #f3f4f6;\n  border-left-color: #111827;\n}\n\n.userPickerAvatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #374151;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.userPickerInfo {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.userPickerNameRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.userPickerName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.userPickerYou {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.userPickerRole {\n  font-size: 12px;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.userPickerBadge {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.dateInput {\n  width: 136px;\n}\n\n.prioritySelect {\n  width: 86px;\n  text-transform: capitalize;\n}\n\n.addSubtaskButton {\n  width: fit-content;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 8px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #4b5563;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.addSubtaskButton:hover {\n  color: #111827;\n  background: #f9fafb;\n}\n\n.modalFooter {\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.modalSecondaryAction,\n.modalPrimaryAction {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.modalSecondaryAction {\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  color: #4b5563;\n}\n\n.modalPrimaryAction {\n  border: none;\n  background: #111827;\n  color: #f9fafb;\n}\n\n.modalPrimaryAction:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: default;\n}\n\n@media (max-width: 720px) {\n  .modalCard {\n    max-width: 100%;\n  }\n\n  .subtaskControlsRow {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .assigneePickerWrap,\n  .dateInput,\n  .prioritySelect {\n    width: 100%;\n  }\n\n  .assigneePopover {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `DelegateSubtasksModal-module__modalOverlay___VWJtZ`,
	"modalCard": `DelegateSubtasksModal-module__modalCard___iKlHj`,
	"modalHeader": `DelegateSubtasksModal-module__modalHeader___EXQ9p`,
	"modalTitle": `DelegateSubtasksModal-module__modalTitle___fxMsZ`,
	"modalSubtitle": `DelegateSubtasksModal-module__modalSubtitle___DgINS`,
	"modalSubtitleStrong": `DelegateSubtasksModal-module__modalSubtitleStrong___brJ8T`,
	"modalBody": `DelegateSubtasksModal-module__modalBody___nMJtF`,
	"subtaskCard": `DelegateSubtasksModal-module__subtaskCard___t6l_f`,
	"subtaskCardHeader": `DelegateSubtasksModal-module__subtaskCardHeader___ONwrk`,
	"subtaskLabel": `DelegateSubtasksModal-module__subtaskLabel___R4cLS`,
	"removeSubtaskButton": `DelegateSubtasksModal-module__removeSubtaskButton___j7xtR`,
	"textInput": `DelegateSubtasksModal-module__textInput___nD7E8`,
	"textarea": `DelegateSubtasksModal-module__textarea___hQMxJ`,
	"dateInput": `DelegateSubtasksModal-module__dateInput___iGW2E`,
	"prioritySelect": `DelegateSubtasksModal-module__prioritySelect___DHP6b`,
	"userSearchInput": `DelegateSubtasksModal-module__userSearchInput___Y6vYO`,
	"subtaskControlsRow": `DelegateSubtasksModal-module__subtaskControlsRow___t7sfG`,
	"assigneePickerWrap": `DelegateSubtasksModal-module__assigneePickerWrap___rCBLo`,
	"assigneeTrigger": `DelegateSubtasksModal-module__assigneeTrigger___F7tTB`,
	"assigneeTriggerActive": `DelegateSubtasksModal-module__assigneeTriggerActive___YENIB`,
	"assigneePlaceholder": `DelegateSubtasksModal-module__assigneePlaceholder___m9FxJ`,
	"assigneePrimary": `DelegateSubtasksModal-module__assigneePrimary___MEDFE`,
	"assigneeSecondary": `DelegateSubtasksModal-module__assigneeSecondary___q22Dv`,
	"userAvatar": `DelegateSubtasksModal-module__userAvatar___WdvCT`,
	"teamAvatar": `DelegateSubtasksModal-module__teamAvatar___i227Z`,
	"assigneePopover": `DelegateSubtasksModal-module__assigneePopover___yKOi0`,
	"assigneePopoverTabs": `DelegateSubtasksModal-module__assigneePopoverTabs___GImiM`,
	"assigneePopoverTab": `DelegateSubtasksModal-module__assigneePopoverTab___OnqVT`,
	"assigneePopoverTabActive": `DelegateSubtasksModal-module__assigneePopoverTabActive___bJiW9`,
	"teamPickerBody": `DelegateSubtasksModal-module__teamPickerBody___YRABz`,
	"teamPickerHint": `DelegateSubtasksModal-module__teamPickerHint___SuQh1`,
	"teamPickerGrid": `DelegateSubtasksModal-module__teamPickerGrid___znmbm`,
	"teamPickerCard": `DelegateSubtasksModal-module__teamPickerCard___yAu9r`,
	"teamPickerCardActive": `DelegateSubtasksModal-module__teamPickerCardActive___exU1B`,
	"teamPickerIcon": `DelegateSubtasksModal-module__teamPickerIcon___SoAqN`,
	"teamPickerLabel": `DelegateSubtasksModal-module__teamPickerLabel___oD43Q`,
	"userPickerBody": `DelegateSubtasksModal-module__userPickerBody___pGHI8`,
	"userSearchWrap": `DelegateSubtasksModal-module__userSearchWrap___I74rj`,
	"userPickerList": `DelegateSubtasksModal-module__userPickerList___RkiHY`,
	"userTeamSection": `DelegateSubtasksModal-module__userTeamSection___RlEaV`,
	"userTeamHeader": `DelegateSubtasksModal-module__userTeamHeader___uaEuj`,
	"userTeamHeaderLeft": `DelegateSubtasksModal-module__userTeamHeaderLeft___xj80y`,
	"userTeamChevron": `DelegateSubtasksModal-module__userTeamChevron___z3XOW`,
	"userTeamChevronOpen": `DelegateSubtasksModal-module__userTeamChevronOpen___zFYut`,
	"userTeamIcon": `DelegateSubtasksModal-module__userTeamIcon___mHOV4`,
	"userTeamTitle": `DelegateSubtasksModal-module__userTeamTitle___Pduap`,
	"userTeamCount": `DelegateSubtasksModal-module__userTeamCount___su4O1`,
	"userTeamList": `DelegateSubtasksModal-module__userTeamList___oKeV_`,
	"userPickerRow": `DelegateSubtasksModal-module__userPickerRow___roGHY`,
	"userPickerRowActive": `DelegateSubtasksModal-module__userPickerRowActive___KCJYY`,
	"userPickerAvatar": `DelegateSubtasksModal-module__userPickerAvatar___HvW_n`,
	"userPickerInfo": `DelegateSubtasksModal-module__userPickerInfo___XZUYx`,
	"userPickerNameRow": `DelegateSubtasksModal-module__userPickerNameRow___OniBM`,
	"userPickerName": `DelegateSubtasksModal-module__userPickerName___Y3GoN`,
	"userPickerYou": `DelegateSubtasksModal-module__userPickerYou___OOCrl`,
	"userPickerRole": `DelegateSubtasksModal-module__userPickerRole___fihjm`,
	"userPickerBadge": `DelegateSubtasksModal-module__userPickerBadge___R6wNl`,
	"addSubtaskButton": `DelegateSubtasksModal-module__addSubtaskButton___W4JbJ`,
	"modalFooter": `DelegateSubtasksModal-module__modalFooter___auuiU`,
	"modalSecondaryAction": `DelegateSubtasksModal-module__modalSecondaryAction___fLCg2`,
	"modalPrimaryAction": `DelegateSubtasksModal-module__modalPrimaryAction___Aip7S`
};
module.exports = ___CSS_LOADER_EXPORT___;
